/**
 * NCC: category circles (sections/ncc-category-circles.liquid).
 *
 * The clicked circle takes the ring at once - the ring and the label transition in the stylesheet - so the choice
 * reads before the next collection arrives; the cross-document page transition then crossfades each circle in
 * place (they carry their own view-transition-name), and the rest of the page settles in around the band.
 */
document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }
  const link = event.target instanceof Element ? event.target.closest('.ncc-circles__link') : null;
  const item = link?.closest('.ncc-circles__item');
  const list = link?.closest('.ncc-circles__list');
  if (!link || !item || !list) return;

  list.querySelectorAll('.ncc-circles__item--active').forEach((active) => {
    active.classList.remove('ncc-circles__item--active');
    active.querySelector('.ncc-circles__link')?.removeAttribute('aria-current');
  });
  item.classList.add('ncc-circles__item--active');
  link.setAttribute('aria-current', 'page');
});
